import React from "react";
import "./About.css";

const About = () => {
	return (
		<div className="about">
			<div className="about__container">
				<div className="about__photo"></div>
				<div className="about__text">
					<h2 className="about__header">Our story</h2>
					<p className="about__p">
						Lorem ipsum, dolor sit amet consectetur adipisicing elit. Fugiat
						accusantium sapiente tempora sed dolore esse deserunt eaque
						excepturi, delectus error accusamus vel eligendi, omnis beatae.
						Quisquam, dicta. Eos quod quisquam esse recusandae vitae neque
						dolore, obcaecati incidunt sequi blanditiis est exercitationem
						molestiae delectus saepe odio eligendi modi porro eaque in libero
						minus unde sapiente consectetur architecto. Ullam rerum, nemo iste
						ex, eaque perspiciatis nisi, eum totam velit saepe sed quos
						similique amet. Ex, voluptate accusamus nesciunt totam vitae esse
						iste.
					</p>
				</div>
			</div>
		</div>
	);
};

export default About;
